import { useCallback, useEffect, useState } from "react";
import { useOnUpdateUserEvents } from "../../../hooks/firestoreHooks/eventListUpdateHook";
import { useAppDispatch } from "../../../hooks/storeHooks";
import { ROUTE_QUERY_CONSTANTS } from "../../../routes";
import { getEventsThunk } from "../../../store/events/eventThunk";
import { EVENT_TYPE } from "../../../types/eventTypes";
import EventGrid from "../EventGrid";

const InProgress = () => {
  const dispatch = useAppDispatch();
  const [shouldStartUpdating, setShouldStartUpdating] = useState(false);

  const fetchEventListData = useCallback(async () => {
    dispatch(
      getEventsThunk({
        type: EVENT_TYPE.IN_PROGRESS,
        isLoading: false,
      })
    );
  }, [dispatch]);

  useOnUpdateUserEvents(shouldStartUpdating, fetchEventListData);

  useEffect(() => {
    const getData = async () => {
      await dispatch(
        getEventsThunk({
          type: EVENT_TYPE.IN_PROGRESS,
          isLoading: true,
        })
      );
      setShouldStartUpdating(true);
    };
    getData();
  }, []);
  return (
    <EventGrid
      gridId={`EVENT_IN_PROGRESS`}
      eventType={"IN_PROGRESS"}
      showSave={false}
      title={"Events in progress"}
      queryParams={ROUTE_QUERY_CONSTANTS.InProgress}
    />
  );
};

export default InProgress;
